export enum TimeoutTypeDropdownOption {
    POKER = 'POKER',
    CASINO = 'CASINO',
    ALL = 'ALL',
}